import { useEffect, useState } from 'react';
import { Card, CardBody, Nav, NavItem, NavLink, Table } from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';

const AdobeSummary = () => {
  const [activeMainTab, setActiveMainTab] = useState('pending');
  const [dataMap, setDataMap] = useState({});
  const [totalCounts, setTotalCounts] = useState({});
  const [statePlanned, setStatePlanned] = useState({});
  const [activeCity, setActiveCity] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalPlanned, setTotalPlanned] = useState(0);

  const apiConfig = [
    {
      key: 'pending',
      label: 'State Head Pending Sites',
      url: 'https://api.outdoorooh.com/api/adobe-state-wise-pending-sites',
    },
    {
      key: 'approved',
      label: 'State Head Approved Sites',
      url: 'https://api.outdoorooh.com/api/adobe-state-wise-approved-sites',
    },
    {
      key: 'vendorPending',
      label: 'Vendor Pending Sites',
      url: 'https://api.outdoorooh.com/api/adobe-state-wise-vendor-pending-sites',
    },
    {
      key: 'vendorApproved',
      label: 'Vendor Approved Sites',
      url: 'https://api.outdoorooh.com/api/adobe-state-wise-vendor-approved-sites',
    },
  ];

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const results = await Promise.all(
          apiConfig.map(async ({ key, url }) => {
            const res = await fetch(url);
            const json = await res.json();
            return {
              key,
              data: json.data || [],
              total: json.total_count,
              planned: json.state_counts_all || [],
              totalall: json.total_count_all || 0,
            };
          })
        );

        const newDataMap = {};
        const newCounts = {};
        const newStatePlanned = {};
        results.forEach(({ key, data, total, planned, totalall }) => {
          newDataMap[key] = data;
          newCounts[key] = total;
          newStatePlanned[key] = planned;
          if (key === 'pending') {
            setTotalPlanned(totalall);
          }
        });

        setDataMap(newDataMap);
        setTotalCounts(newCounts);
        setStatePlanned(newStatePlanned);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchAllData();
  }, []);

  const currentTabData = dataMap[activeMainTab] || [];

  const filteredData = currentTabData
    .filter((state) => !activeCity || state.state === activeCity)
    .flatMap((state) =>
      state.projects.filter((site) => {
        const search = searchTerm.toLowerCase();
        return (
          site.site_name?.toLowerCase().includes(search) ||
          site.code?.toLowerCase().includes(search)||
          site.zone?.toLowerCase().includes(search)||
          site.state?.toLowerCase().includes(search)

        );
      })
    );

  const plannedCountForState = (stateName) => {
    const found = statePlanned[activeMainTab]?.find((s) => s.state === stateName);
    return found?.count || 0;
  };
const downloadExcel = () => {
  if (!filteredData.length) return;

  const excelData = filteredData.map((site, index) => ({
    'S.No': index + 1,
    'Site Code': site.code,
    'Site Name': site.site_name,
    Zone: site.zone,
    State: site.state,
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sites');

  XLSX.writeFile(
    workbook,
    `UPE_Sites_${activeMainTab}_${activeCity || 'All'}_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`
  );
};

  return (
    <Card>
      <CardBody>
       <div className='d-flex justify-content-between'>
         <h4>
          All Site Honda Overview: Total Planned Sites - {totalPlanned}
        </h4>
<button
  className="btn btn-success mb-3"
  type='button'
  onClick={downloadExcel}
  disabled={!filteredData.length}
>
  Download Excel
</button>
       </div>

        {/* Main Tabs */}
        <Nav tabs className="mb-3">
          {apiConfig.map(({ key, label }) => (
            <NavItem key={key}>
              <NavLink
                className={classnames({ active: activeMainTab === key })}
                onClick={() => {
                  setActiveMainTab(key);
                  setActiveCity(null);
                  setSearchTerm('');
                }}
                style={{ cursor: 'pointer' }}
              >
                {label} ({totalCounts[key] || 0})
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        {/* City Tabs */}
        <Nav tabs className="mb-3">
          <NavItem>
            <NavLink
              className={classnames({ active: activeCity === null })}
              onClick={() => setActiveCity(null)}
              style={{ cursor: 'pointer' }}
            >
              All Cities
            </NavLink>
          </NavItem>
          {currentTabData
            .filter((s) => s.state !== 'South')
            .map((s) => (
              <NavItem key={s.state}>
                <NavLink
                  className={classnames({ active: activeCity === s.state })}
                  onClick={() => setActiveCity(s.state)}
                  style={{ cursor: 'pointer' }}
                >
                  {s.state} ({s.count}) | Planned: {plannedCountForState(s.state)}
                </NavLink>
              </NavItem>
            ))}
        </Nav>

        {/* Search Bar */}
        <input
          type="text"
          placeholder="Search site name or code..."
          className="form-control mb-3"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {/* Table */}
        {filteredData.length > 0 ? (
          <Table bordered responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Code</th>
                <th>Site Name</th>
                <th>Zone</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((site, i) => (
                <tr key={site.code || i}>
                  <td>{i + 1}</td>
                  <td>
                    <Link to={`/honda-project-detail/${site.id}`}>{site.code}</Link>
                  </td>
                  <td>
                    <Link to={`/honda-project-detail/${site.id}`}>{site.site_name}</Link>
                  </td>
                  <td>{site.zone}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>No data available.</p>
        )}
      </CardBody>
    </Card>
  );
};

export default AdobeSummary;
